import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { Button, Typography } from 'seagull';
import { DropdownMenu } from 'seagull/components/DropdownMenu';
import { ChevronDown, ChevronUp, DocumentCheckmark, EmailSent, Trash } from 'seagull/icons';
import { Intent } from '~/infra/access-control';
import pluralize from '~/utils/pluralize';
import styles from './DraftsDashboard.module.scss';
const BulkActions = (param)=>{
    let { numSelected, setBulkActionsOpen, bulkActionsOpen, bulkSend, bulkExternallySign, bulkDiscard } = param;
    return /*#__PURE__*/ _jsxs(_Fragment, {
        children: [
            numSelected > 0 && /*#__PURE__*/ _jsx(Typography, {
                testId: "drafts-dashboard-bulk-counter",
                children: "".concat(numSelected, " ").concat(pluralize('draft', numSelected), " selected")
            }),
            /*#__PURE__*/ _jsx(DropdownMenu, {
                onOpenChange: setBulkActionsOpen,
                target: /*#__PURE__*/ _jsx(Button, {
                    testId: "drafts-dashboard-bulk-actions",
                    skin: "primaryOutline",
                    suffixIcon: bulkActionsOpen ? /*#__PURE__*/ _jsx(ChevronUp, {}) : /*#__PURE__*/ _jsx(ChevronDown, {}),
                    disabled: numSelected === 0,
                    children: "Bulk actions"
                }),
                children: [
                    {
                        icon: /*#__PURE__*/ _jsx(EmailSent, {
                            size: 20
                        }),
                        testId: 'drafts-dashboard-bulk-send',
                        text: 'Send proposals',
                        onClick: bulkSend
                    },
                    {
                        icon: /*#__PURE__*/ _jsx(DocumentCheckmark, {
                            size: 20
                        }),
                        testId: 'drafts-dashboard-bulk-externally-sign',
                        text: 'Approve on behalf of the client',
                        onClick: bulkExternallySign
                    },
                    {
                        icon: /*#__PURE__*/ _jsx(Trash, {
                            size: 20
                        }),
                        testId: 'drafts-dashboard-bulk-remove',
                        text: 'Discard drafts',
                        intent: Intent.DiscardDraft,
                        skin: 'error',
                        onClick: bulkDiscard
                    }
                ].map((param)=>{
                    let { icon, testId, text, intent, skin, onClick } = param;
                    return /*#__PURE__*/ _jsx(DropdownMenu.Item, {
                        iconStart: /*#__PURE__*/ _jsx("div", {
                            className: styles.bulkActionIcon,
                            children: icon
                        }),
                        testId: testId,
                        intent: intent,
                        skin: skin,
                        onClick: onClick,
                        children: text
                    }, testId);
                })
            })
        ]
    });
};
export default BulkActions;
